<template>
  <v-text-field
    v-bind="computedProps"
    label=""
    solo
    flat
    :placeholder="phtext"
    :tabindex="readonly ? -1 : 0"
    @input="onInput"
    @blur="onBlur"
    @focus="onFocus"
    @keydown.enter="onKeydownEnter"
    @keydown.tab="onKeydownTab"
    @keydown.esc="onKeydownEsc"
  >
    <template v-slot:append>
      <slot name="append"/>
    </template>
  </v-text-field>
</template>
<script>
import controls from '@/rahmen/controls'
import validators from '@/rahmen/validators'
import inputMixin from '@/mixins/inputMixins'
import core from '@/rahmen/core'
import { VTextField } from 'vuetify/lib'

/**
 * @file DDv2用数値テキスト
 * @namespace components
 */

/**
 * @vue-prop {Boolean} [required=false] - 必須指定
 * @vue-prop {Number} [integerDigit=String(Number.MAX_SAFE_INTEGER).length] - 整数部桁数指定
 * @vue-prop {Number} [minorDigit=0] - 少数部桁数指定
 * @vue-prop {Number} [max=Number.MAX_SAFE_INTEGER] - 許容最大値
 * @vue-prop {Number} [min=Number.MAX_SAFE_INTEGER * -1] - 許容最小値
 * @vue-prop {String} [errorMessages=''] - エラーメッセージ
 * @see https://vuetifyjs.com/ja/api/v-text-field/
 * @example
  <dd-numeric-box
    label="数値"
    v-model="numericValue"
    :required="true"
    :integerDigit="5"
    :minorDigit="2"
    />
 */
export default {
  name: 'DdSpreadSheetNumericBox',
  extends: VTextField,
  mixins: [inputMixin],
  props: {
    /**
     * 必須指定
     */
    required: Boolean,
    /**
     * 正数部桁数指定
     */
    integerDigit: {
      type: Number,
      default: String(Number.MAX_SAFE_INTEGER).length
    },
    /**
     * 小数部桁数指定
     */
    minorDigit: {
      type: Number,
      default: 0
    },
    /**
     * 入力可能最大値
     */
    max: {
      type: Number,
      default: Number.MAX_SAFE_INTEGER
    },
    /**
     * 入力可能最小値
     */
    min: {
      type: Number,
      default: Number.MAX_SAFE_INTEGER * -1
    },
    /**
     * 表示エラーメッセージ
     */
    errorMessages: String,
    /**
     * 追加フォーマッタ
     */
    appendFormatter: Function,
    appendUnFormatter: Function
  },
  data: () => ({
    phtext: '',
    hasFocus: false,
    formatedText: '',
    isNegativeValue: false,
    invalidMessage: '',
    innerValue: ''
  }),
  created () {
    this.formatedText = this.value
    this.innerValue = this.getSanitizedValue(this.value)
  },
  mounted () {
    console.log(this.name, 'mounted', this)
    const dtl = controls.getInputTypeDetail(controls.InputTypes.Numerical)
    if (!dtl) { return }
    console.log('dtl', dtl)
    this.phtext = !this.readonly ? dtl.placeholder.replace('@@length@@', this.integerDigit) : ''
    this.invalidMessage = this.errorMessages
    console.log('formatedText', this.formatedText)
  },
  watch: {
    /* readonly: function (n, o) {
      this.isReadonly = n
    }, */
    value: function (n, o) {
      this.innerValue = this.getSanitizedValue(n)
      this[controls.FORMAT_METHOD]()
    }
  },
  computed: {
    computedProps () {
      return {
        ...this.$props,
        // backgroundColor: this.required ? controls.Colors.Required : '',
        type: 'number',
        hideDetails: 'auto',
        dense: true,
        value: this.innerValue,
        class: this.$props.class + ' numeric-input' + (this.required ? ' required-item' : ''),
        error: this.hasError,
        errorMessages: this.invalidMessage
      }
    },
    hasError () {
      return this.invalidMessage !== '' && this.invalidMessage !== undefined
    }
  },
  methods: {
    getSanitizedValue (inputVal) {
      if (typeof inputVal === 'string' && inputVal !== '') {
        var retVal = inputVal.replaceAll(',', '')
        if (isFinite(retVal)) {
          return parseFloat(retVal)
        } else {
          return ''
        }
      }
      return inputVal
    },
    onInput: function (e) {
      // console.log('onInput', e)
      this.innerValue = e
    },
    onBlur: function (e) {
      console.log('onBlur', e, this.hasFocus)
      this.$set(this, 'hasFocus', false)
      console.log(this.computedPropsForText)
      console.log(this.hasFocus)
      this.$emit('input', this.innerValue)

      this[controls.VALIDATE_METHOD]()
      if (!this.hasError) {
        this[controls.FORMAT_METHOD]()
      }
      this.$emit('blur', e)
    },
    /*
    onFocus: function (e) {
      console.log('onFocus', e, this.hasFocus)
      this.$set(this, 'hasFocus', true)
      console.log(this.hasFocus)
      let val = '' + e.target.value
      val = val.replaceAll(',', '')
      e.target.value = val

      const elem = this.$el.querySelector('input')
      if (elem) { elem.select() }

      this.$emit('focus', e)
    },
    */
    onFocus: function (e) {
      console.log('onFocus', e)
      if (typeof this.appendUnFormatter === 'function' && this.appendUnFormatter) {
        this.innerValue = this.appendUnFormatter(this.innerValue)
      }

      // let val = '' + e.target.value
      // val = val.replaceAll(',', '')
      // e.target.value = val

      const elem = this.$el.querySelector('input')
      this.$nextTick().then(() => {
        if (elem) { elem.select() }
        this.$emit('focus', e)
      })
    },
    onKeydownEnter: function (e) {
      // console.log('onKeydownEnter')
      this.$emit('enter', e)
    },
    onKeydownTab: function (e) {
      // console.log('onKeydownTab')
      this.$emit('tab', e)
    },
    onKeydownEsc: function (e) {
      // console.log('onKeydownEsc')
      this.$emit('esc', e)
    },
    [controls.VALIDATE_METHOD]: function () {
      const target = {
        value: this.innerValue,
        intDigit: this.integerDigit,
        decimalDigit: this.minorDigit,
        max: this.max,
        min: this.min
      }
      console.log(target)
      this.invalidMessage = undefined
      const validatorList = controls.getInputTypeValidators(controls.InputTypes.Numerical)

      if (!this.required && target.value === '') { return }
      if (this.required) { validatorList.unshift(validators.requireValidate) }
      if (this.appendValidators) { validatorList.push(...this.appendValidators) }

      for (let i = 0; i < validatorList.length; i++) {
        const f = validatorList[i]
        const ret = f(target)
        if (ret !== undefined) {
          this.invalidMessage = ret
          return
        }
      }
    },
    [controls.FORMAT_METHOD]: function () {
      const val = String(this.innerValue)
      if (val === 'undefined' || val === '' || val === 'null') {
        this.formatedText = ''
        return
      }
      const num = this.minorDigit === 0 ? parseInt(val, 10) : parseFloat(val, 10)
      let formated = num.toLocaleString(undefined, { maximumFractionDigits: 20 })

      if (this.minorDigit !== 0) {
        console.log('1', formated)
        const dotPosition = formated.lastIndexOf('.')
        if (dotPosition === -1) {
          formated += `.${'0'.repeat(this.minorDigit)}`
        } else {
          const minorLen = formated.split('.')[1].length
          formated += '0'.repeat(this.minorDigit - minorLen)
        }
      }

      this.formatedText = formated
      this.isNegativeValue = core.isNegativeValue(val)
    }
  }
}
</script>
<style>
.numeric-input input {
  text-align: right;
}

.numeric-input.negative input {
  color: red;
}
</style>
